import type {
  Answer,
  AnswerElementsItem,
  Markdown,
  Table,
} from "../../types";
import { TableView } from "../../../structured_output/components/TableView";
import styles from "./TraceAnswerElements.module.css";

export interface TraceAnswerElementsProps {
  answer: Answer;
}

function AnswerElement({ element }: { element: AnswerElementsItem }) {
  switch (element.element_kind) {
    case "table":
      return <TableView table={element as Table} />;
    case "markdown":
      return (
        <p className={styles.markdown}>{(element as Markdown).markdown}</p>
      );
    case "linegraph":
      return (
        <p className={styles.graphPlaceholder}>
          [graph omitted from trace preview]
        </p>
      );
    default:
      return null;
  }
}

export function TraceAnswerElements({ answer }: TraceAnswerElementsProps) {
  return (
    <div className={styles.container} data-testid="trace-answer-elements">
      {answer.elements.map((element, index) => (
        <AnswerElement key={index} element={element} />
      ))}
    </div>
  );
}
